/**
 * @generated SignedSource<<a7583fcbb09675d9cbac10653778e945>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePdpSharedTracking_user$data = {
  readonly canShowSellerName: boolean | null;
  readonly " $fragmentType": "usePdpSharedTracking_user";
};
export type usePdpSharedTracking_user$key = {
  readonly " $data"?: usePdpSharedTracking_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePdpSharedTracking_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePdpSharedTracking_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canShowSellerName",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5ce2434dcdf18eb2e429bd533d01e754";

export default node;
